import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import { get } from 'lodash';
import { payeePropTypes } from '../../../sharedComponents/PayeeList/propTypes';
import withContent from '../../../containers/withContent';
import { withScrollTop } from '../../../containers/withScrollTop';
import pageContent from '../ChapsPayments/chapsPayment.content';
import { getPayees } from '../../../states/payees/selectors';
import { goToPage, pages, setBackPage } from '../../../states/page/actions';
import { toggleBatch, toggleBatchIfEligible } from '../../../states/batch/actions';
import {
	addMultiplePayments,
	removePayment,
	updateReference,
	updateDate,
	updateToAccount,
	updateFromAccount,
} from '../../../states/payments/actions';
import {
	getReference,
	updatePayeeSingularCountMessage,
	hasPreviousCopCheckPerformed,
	hasAllRequiredCopFields,
} from '../../../helpers/fieldHelpers';
import { clearSelectedPayment, setSelectedPaymentId } from '../../../states/payeeSelector/actions';
import PayeesPage from '../../../sharedComponents/PayeesPage/PayeesPage';
import {
	getSelectedPaymentId,
	getSelectedFromAccount,
	getFromAccountCanPayBenificiaries,
} from '../../../states/payeeSelector/selectors';
import { getChapsPaymentsList, getToAccount, getChapsPaymentCount } from '../../../states/chaps/selectors';
import {
	chapsUpdatePaymentAccounts,
	addChapsPayments,
	chapsDeletePayment,
	chapsUpdatePayment,
} from '../../../states/chaps/actions';
import { getFromAccounts } from '../../../states/accounts/selectors';
import { TYPE_CHAPS } from '../../../config';
import { getChapsPaymentLimit } from '../../../states/envConfig/selectors';
import { getPayeeById } from '../../../states/commonSelectors/selectors';
import { goToEditPayeePage } from '../../../states/api/fasterPaymentActions';
import { setSelectedPayee } from '../../../managePayee/states/action';
import { getPage } from '../../../states/page/selectors';
import { COPCheck } from '../../../sharedComponents/COPCheck/COPCheck';
import { getLastPayment } from '../../../states/payments/selectors'; //TODO: This is the wrong selector, this is fixed on the payments slice
import { removePayee } from '../../../states/payees/actions';

const isPayeeBiller = (payees, id) =>
	get(
		payees.find((payee) => payee.id === id),
		'isBiller',
		false
	);

const mapState = (state) => ({
	toPayees: getPayees(state),
	selectedPaymentId: getSelectedPaymentId(state),
	fromAccount: getSelectedFromAccount(state),
	payments: getChapsPaymentsList(state),
	toAccount: getToAccount(state),
	canPayBeneficiaries: getFromAccountCanPayBenificiaries(state),
	fromAccounts: getFromAccounts(state),
	paymentCount: getChapsPaymentCount(state),
	paymentLimit: getChapsPaymentLimit(state),
	getPayeeById: (id) => getPayeeById(state, id),
	currentPage: getPage(state),
	lastPayment: getLastPayment(state),
});

const mapDispatch = (dispatch) => ({
	goToPayeeSelector: () => dispatch(goToPage(pages.FasterPaymentsPayeeSelector)),
	toggleIsBatch: (isBatch) => dispatch(toggleBatch(isBatch)),
	addMultiplePayments: (payments) => dispatch(addMultiplePayments(payments)),
	selectToAccount: (paymentId, accountId, toPayees) => {
		dispatch(updateToAccount({ id: paymentId, accountId }));
		dispatch(updateReference({ id: paymentId, reference: getReference(toPayees, accountId, true) }));
		if (isPayeeBiller(toPayees, accountId)) {
			dispatch(updateDate({ id: paymentId, date: moment() }));
		}
	},
	clearSelectedPayment: () => dispatch(clearSelectedPayment()),
	handleRemovePayment: (id) => dispatch(removePayment({ id })),
	updateFromAccount: ({ id, accountId }) => dispatch(updateFromAccount({ id, accountId })),
	addPayments: (fromAccount, toAccounts, lastPaymentDate, toPayees) =>
		dispatch(addChapsPayments({ fromAccount, toAccounts, lastPaymentDate, toPayees })),
	updatePaymentAccounts: ({ fromAccount, toAccounts, toPayees }, paymentId) =>
		dispatch(chapsUpdatePaymentAccounts({ fromAccount, toAccounts, toPayees }, paymentId)),
	continueToPayments: () => dispatch(goToPage(pages.ChapsPayments)),
	toggleBatchIfEligible: () => dispatch(toggleBatchIfEligible(TYPE_CHAPS)),
	goToEditPayeePage: (isCOPEdit) => dispatch(goToEditPayeePage(isCOPEdit)),
	setSelectedPayee: (payee) => dispatch(setSelectedPayee(payee)),
	setBackPage: (page) => {
		dispatch(setBackPage(page));
	},
	setSelectedPayment: (id) => dispatch(setSelectedPaymentId(id)),
	removePayee: (payeeId) => dispatch(removePayee(payeeId)),
	chapsRemovePayment: (id) => dispatch(chapsDeletePayment(id)),
	updatePayment: ({ paymentId, formKey, value }) => dispatch(chapsUpdatePayment({ paymentId, formKey, value })),
});

class ChapsPayeePage extends Component {
	constructor(props) {
		super(props);

		this.handlePayeeListContinue = this.handlePayeeListContinue.bind(this);
		this.handlePayeeListContinue = this.handlePayeeListContinue.bind(this);
		this.handleCOPSuccess = this.handleCOPSuccess.bind(this);
		this.handleCOPCancel = this.handleCOPCancel.bind(this);
		this.handleEditPayee = this.handleEditPayee.bind(this);

		this.state = { isCOPCheckRequired: false, payeeId: '' };
	}

	handleEditPayee(selectedPayee, isCOPEdit = false) {
		const { setSelectedPayee, goToEditPayeePage, currentPage, setBackPage } = this.props;
		setSelectedPayee(selectedPayee);
		setBackPage(currentPage);
		goToEditPayeePage(isCOPEdit);
	}

	handlePayeeListContinue(selectedToPayees) {
		const {
			addPayments,
			continueToPayments,
			updatePaymentAccounts,
			toggleBatchIfEligible,
			firstSubmissionDate,
			fromAccount,
			selectedPaymentId,
			clearSelectedPayment,
			getPayeeById,
			toPayees,
			updatePayment,
		} = this.props;
		if (selectedPaymentId) {
			updatePaymentAccounts({ fromAccount, toAccounts: selectedToPayees, toPayees }, selectedPaymentId);
		} else {
			addPayments(fromAccount, selectedToPayees, firstSubmissionDate, toPayees);
			toggleBatchIfEligible();
		}

		if (selectedToPayees.length === 1) {
			const payee = getPayeeById(selectedToPayees[0]);
			updatePayment({
				paymentId: selectedPaymentId,
				formKey: 'chapsReference',
				value: get(payee, 'reference_high_value'),
			});
			if (!hasPreviousCopCheckPerformed(payee)) {
				if (hasAllRequiredCopFields(payee)) {
					this.setState({ isCOPCheckRequired: true, payeeId: selectedToPayees[0] });
				} else {
					this.handleEditPayee(payee, true);
				}
				return;
			}
		}

		clearSelectedPayment();
		return continueToPayments();
	}

	handleCOPSuccess() {
		this.props.continueToPayments();
	}

	handleCOPCancel() {
		const {
			lastPayment: { id: paymentId },
			selectedPaymentId: isPaymentBeingEdited,
			setSelectedPayee,
			chapsRemovePayment,
		} = this.props;
		if (isPaymentBeingEdited) {
			setSelectedPayee(null);
		} else if (paymentId) {
			chapsRemovePayment(paymentId);
		} else {
			chapsRemovePayment(get(this.props, 'payments[0].id'));
		}
		this.setState({ isCOPCheckRequired: false });
	}

	handleCOPEdit = (payeeId) => {
		const payee = this.props.getPayeeById(payeeId);
		this.handleEditPayee(payee, true);
	};

	render() {
		const {
			toPayees,
			content: { header },
			content,
			copCheckTriggered,
			paymentCount,
			toAccount,
			updateFromAccount,
			canPayBeneficiaries,
			fromAccounts,
			paymentLimit,
			handleDisplayFullwidth,
			sessionCOPChecks,
		} = this.props;
		const { isCOPCheckRequired, payeeId } = this.state;

		if (isCOPCheckRequired) {
			return (
				<COPCheck
					copCheckTriggered={copCheckTriggered}
					handleComplete={this.handleCOPSuccess}
					handleCancel={this.handleCOPCancel}
					handleEdit={this.handleCOPEdit}
					payeeId={payeeId}
					sessionCOPChecks={sessionCOPChecks}
				/>
			);
		}

		const updatedContent = updatePayeeSingularCountMessage(content, paymentLimit);

		return (
			<PayeesPage
				toPayees={toPayees}
				header={header}
				description=""
				content={updatedContent}
				paymentCount={paymentCount}
				toAccount={toAccount}
				onPayeeListContinue={this.handlePayeeListContinue}
				updateFromAccount={updateFromAccount}
				canPayBeneficiaries={canPayBeneficiaries}
				fromAccounts={fromAccounts}
				paymentLimit={paymentLimit}
				handleDisplayFullwidth={handleDisplayFullwidth}
			/>
		);
	}
}

ChapsPayeePage.propTypes = {
	content: PropTypes.shape({}).isRequired,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)).isRequired,
	continueToPayments: PropTypes.func.isRequired,
	paymentCount: PropTypes.number.isRequired,
	updateFromAccount: PropTypes.func.isRequired,
	toAccount: PropTypes.string,
	addPayments: PropTypes.func,
	updatePaymentAccounts: PropTypes.func.isRequired,
	toggleBatchIfEligible: PropTypes.func.isRequired,
	firstSubmissionDate: PropTypes.instanceOf(moment),
	fromAccount: PropTypes.string,
	selectedPaymentId: PropTypes.string,
	canPayBeneficiaries: PropTypes.bool,
	fromAccounts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
	clearSelectedPayment: PropTypes.func.isRequired,
	paymentLimit: PropTypes.number,
	lastPayment: PropTypes.object.isRequired,
	handleDisplayFullWidth: PropTypes.func,
	copCheckTriggered: PropTypes.func,
	sessionCOPChecks: PropTypes.object,
};
export const connectWrapper = connect(mapState, mapDispatch)(ChapsPayeePage);

export default compose(withScrollTop, withContent({ content: pageContent }))(connectWrapper);
